import React from 'react';
import { Edit } from 'react-admin';
import LayerForm from '../LayerForm';

function LayerEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <LayerForm redirect="list" />
    </Edit>
  );
}

export default LayerEdit;
